{
    "nav": {
        "dashboard": "Branch queues",
        "appointments": "Appointments",
        "hardware": "Branch hardware",
        "configuration": "Services and counters",
        "simulator": "Branch simulator"
    },

    "pairing": {
        "title": "Pair this device",
        "description": "Enter the six-character code shown in Branch hardware.",
        "code": "Pairing code",
        "submit": "Pair device",
        "paired": "Paired with {{branch}}.",
        "unpair": "Unpair this device",
        "unpair_confirm": "Unpair this device? It will stop showing the queue until it is paired again.",
        "invalid": "That code was not accepted."
    },

    "kiosk": {
        "welcome": "Welcome",
        "choose_service": "Please choose a service",
        "identify": "Are you a customer of the Bank?",
        "identify_hint": "Enter your civil ID to have this visit added to your record. This is optional.",
        "civil_id": "Civil ID",
        "skip": "Continue without identifying",
        "issue": "Take a ticket",
        "issuing": "Issuing your ticket…",
        "your_number": "Your number",
        "now_serving_short": "Now serving",
        "people_waiting": "{{count}} waiting",
        "people_waiting_one": "1 waiting",
        "about_minutes": "About {{count}} min",
        "over_minutes": "Over {{count}} min",
        "not_serving": "Not available now",
        "identified": "Added to your record",
        "print": "Print",
        "done": "Done",
        "another": "Take another ticket",
        "closing_in": "This screen returns in {{count}}s"
    },

    "display": {
        "now_serving": "Now serving",
        "counter": "Counter",
        "next": "Next",
        "waiting": "Waiting",
        "open_counters": "Open counters",
        "nothing_serving": "No numbers are being called",
        "recall": "Repeat call",
        "sound_on": "Sound on",
        "sound_off": "Sound off",
        "sound_hint": "Announcements are spoken in Arabic and English."
    },

    "counter": {
        "title": "Counter {{code}}",
        "open": "Open counter",
        "pause": "Pause",
        "close": "Close counter",
        "pause_reason": "Reason (optional)",
        "call_next": "Call next",
        "recall": "Call again",
        "start": "Start serving",
        "complete": "Complete",
        "no_show": "Did not attend",
        "recycle": "Return to queue",
        "transfer": "Transfer to…",
        "current": "At the counter",
        "nobody": "Nobody at the counter",
        "queue": "Waiting at this branch",
        "not_servable": "Another counter",
        "served_today": "Served today",
        "mean_service": "Average service time",
        "no_shows": "Did not attend",
        "waiting_for": "Waiting {{time}}",
        "attempts": "Called {{count}} times",
        "closed_notice": "This counter is closed. Open it to start calling customers.",
        "paused_notice": "This counter is paused. The wait estimate does not count it.",
        "vip": "VIP",
        "assistance": "Needs assistance",
        "view_customer": "Open customer record"
    },

    "dashboard": {
        "title": "Branch queues",
        "subtitle": "Live across the network",
        "waiting": "Waiting now",
        "serving": "Being served",
        "completed": "Served today",
        "alerting": "Branches needing attention",
        "branch": "Branch",
        "open_counters": "Open",
        "longest_wait": "Longest wait",
        "mean_wait": "Average wait",
        "target": "Target",
        "met_target": "Within target",
        "no_shows": "No-shows",
        "alert": "Status",
        "map": "Network",
        "forecast": "Expected demand",
        "forecast_for": "Expected demand at {{branch}}",
        "hour": "Hour",
        "expected": "Expected customers",
        "suggested": "Suggested counters",
        "no_forecast": "Not enough history at this branch yet.",
        "alerts": {
            "ok": "Within target",
            "warning": "Over target",
            "critical": "Well over target",
            "closed": "Closed",
            "closed_with_queue": "Closed with people waiting"
        }
    },

    "appointments": {
        "title": "Appointments",
        "reference": "Reference",
        "when": "Scheduled",
        "customer": "Customer",
        "contact": "Contact",
        "service": "Service",
        "branch": "Branch",
        "status": "Status",
        "confirm": "Confirm",
        "reschedule": "Reschedule",
        "cancel": "Cancel",
        "check_in": "Check in",
        "reschedule_title": "Move this appointment",
        "reschedule_to": "New date and time",
        "cancel_title": "Cancel this appointment",
        "cancel_reason": "Reason",
        "empty": "No appointments match these filters.",
        "walk_in": "Not a registered customer",
        "statuses": {
            "booked": "Booked",
            "confirmed": "Confirmed",
            "checked_in": "Checked in",
            "completed": "Completed",
            "cancelled": "Cancelled",
            "no_show": "Did not attend"
        }
    },

    "hardware": {
        "title": "Branch hardware",
        "device": "Device",
        "branch": "Branch",
        "type": "Type",
        "serial": "Serial number",
        "version": "App version",
        "battery": "Battery",
        "last_seen": "Last seen",
        "state": "State",
        "warranty": "Warranty",
        "online": "Online",
        "offline": "Offline",
        "unpaired": "Not paired",
        "pair": "Issue pairing code",
        "refresh": "Reload device",
        "pairing_code_is": "Pairing code: {{code}}",
        "pairing_code_hint": "Enter this on the device. It works once.",
        "warranty_expired": "Expired",
        "never_seen": "Never",
        "empty": "No devices are registered.",
        "types": {
            "kiosk": "Kiosk",
            "display": "Hall display",
            "counter": "Counter terminal",
            "printer": "Printer"
        }
    },

    "configuration": {
        "title": "Services and counters",
        "services": "Services",
        "counters": "Counters",
        "code": "Code",
        "name": "Name",
        "prefix": "Ticket letter",
        "default_minutes": "Expected minutes",
        "remote": "Remote queue",
        "appointment": "Appointments",
        "active": "Active",
        "serves": "Serves",
        "serves_all": "All services",
        "priority_only": "Priority only",
        "status": "Status",
        "save": "Save counter",
        "edit": "Edit",
        "new_counter": "Add counter",
        "counter_code": "Counter code",
        "name_en": "Name (English)",
        "name_ar": "Name (Arabic)",
        "statuses": {
            "open": "Open",
            "paused": "Paused",
            "closed": "Closed"
        }
    },

    "join": {
        "title": "Join the queue before you set off",
        "subtitle": "Take your place from home and arrive when it is nearly your turn.",
        "branch": "Branch",
        "service": "Service",
        "phone": "Mobile number",
        "name": "Name (optional)",
        "submit": "Join the queue",
        "check": "Check my place",
        "number": "Ticket number",
        "position": "You are number {{position}} in the queue",
        "estimated": "About {{count}} minutes",
        "unknown_wait": "The branch is not serving this yet",
        "cancel": "Give up my place",
        "cancel_confirm": "Give up your place in the queue?",
        "cancelled": "Your place has been released.",
        "called": "Your number has been called — please go to {{counter}}.",
        "not_found": "No ticket matches that number and phone number for today.",
        "choose_branch": "Choose a branch",
        "choose_service": "Choose a service",
        "have_ticket": "I already have a ticket",
        "back_to_join": "Join a queue instead"
    },

    "simulator": {
        "title": "Branch simulator",
        "description": "Drives a branch's queue so the display, kiosk and dashboard can be demonstrated without anybody standing at a counter.",
        "branch": "Branch",
        "arrivals": "Customers to add",
        "run": "Run",
        "running": "Running…",
        "step": "Serve one customer",
        "clear": "Clear today's queue",
        "cleared": "Today's queue at this branch has been cleared.",
        "added": "Added {{count}} customers to the queue.",
        "served": "Served {{number}}.",
        "nothing": "Nobody is waiting.",
        "warning": "This writes real tickets to the selected branch."
    },

    "priority": {
        "0": "Standard",
        "1": "Appointment",
        "2": "VIP",
        "3": "Elderly",
        "4": "Needs assistance",
        "5": "Pregnant"
    },

    "status": {
        "waiting": "Waiting",
        "called": "Called",
        "serving": "Being served",
        "completed": "Completed",
        "no_show": "Did not attend",
        "cancelled": "Cancelled",
        "transferred": "Transferred"
    }
}
